<div class="ui icon input fluid">
  <input
    type="text"
    placeholder="{{ 'txt_search_field_placeholder' | translate }}"
    [ngModel]="templateName$ | async"
    (ngModelChange)="onTemplateNameChange($event)"
  />
  <i class="search icon"></i>
</div>
